export default __webpack_public_path__ + "static/media/stake-more-om-etc.57084469.svg";